export default class ClubEmployee {
    static fromData(data) {
        if (!data) {
            return;
        }

        const employee = new ClubEmployee();
        employee.id = data.id;
        employee.firstName = data.firstName;
        employee.lastName = data.lastName;
        employee.clubId = data.clubId;
        employee.isShortProfileViewable = data.isShortProfileViewable;
        employee.fullName = `${data.firstName} ${data.lastName}`;

        Object.seal(employee);
        return employee;
    }

    static fromLoginData(data) {
        if (!data) {
            return;
        }

        const employee = new ClubEmployee();
        employee.id = data.id;
        employee.contactEmail = data.contactEmail;
        employee.enabled = data.enabled;
        employee.lastLogin = data.lastLogin;

        return employee;
    }
}
